<template
  v-loading="false"
  :element-loading-text="$locale('global.loading')"
  element-loading-spinner="el-icon-loading"
>
  <div ref="page" class="page-content transactionHistory" style="height: calc(100vh - 100px);display:flex;flex-direction:column;">
    <h1 class="page-title" style="height: 31px;">{{ $locale("sideMenu.reports.ticketTransaction") }}</h1>
      <!-- Search Area -->
    <el-row class="search-area">
        <el-col  class="makeInline"  :lg="16" :md="24" :sm="24">
          <DatePickerGroup
            v-bind:start="timeValue1"
            v-bind:end="timeValue2"
            @setFatherDate="getDate"
          ></DatePickerGroup>
          <el-button class="egl-btn-yellow " @click="search" :style="{'margin-bottom':'5px'}">
            {{ $locale("global.search") }}
          </el-button>
        </el-col>
        <el-col class="ta-r" :lg="8" :md="24" :sm="24">
          <el-button @click="exportCsv" class="egl-btn-yellow"
            >{{ $locale("global.exportToCSV") }}</el-button
          >
          <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <el-row class="search-area">
      <el-col :span="24" class="filter-options">
        <CusInputItem :title="$locale('trans.koisk.transid')" :inputData="id" name="id" :changeAction="cusInputFn" />
        <CusInputItem
          :title="$locale('trans.report.zhLastName')"
          :inputData="chineseLastName"
          name="zhLastName"
          :changeAction="cusInputFn"
        />
        <CusInputItem
          :title="$locale('trans.report.zhFirstName')"
          :inputData="chineseName"
          name="zhFirstName"
          :changeAction="cusInputFn"
        />
        <CusInputItem
          :title="$locale('trans.report.jpLastName')"
          :inputData="japaneseLastName"
          name="jpLastName"
          :changeAction="cusInputFn"
        />
        <CusInputItem
          :title="$locale('trans.report.jpFirstName')"
          :inputData="japaneseName"
          name="jpFirstName"
          :changeAction="cusInputFn"
        />
        <CusInputItem
          :title="$locale('setting.brand.tel')"
          :inputData="phone"
          name="phone"
          :changeAction="cusInputFn"
        />
        <CusInputItem
          :inputData="email"
          :title="$locale('global.email')"
          name="email"
          :changeAction="cusInputFn"
        />
        <div class="inputItem">
<!--          <el-select-->
<!--              v-model="filmId"-->
<!--              :placeholder="$locale('trans.report.ticketing.plsInputFilmName')"-->
<!--              clearable-->
<!--              @change="selectFilm_fn"-->
<!--            >-->
<!--              <el-option v-for="(film, idx) in filmListForSearch" :key="idx" :value="film.value" :label="film.text"></el-option>-->
<!--            </el-select>-->
          <el-tooltip placement="top">
            <div slot="content">
              承認済みの作品、作成日付順、降順（最近作成した作品は上に表示）
              <br/>
              先着20作品遅延ロードの仕組み
              <br />
              作品A、7月31日作成
              <br />
              作品B、7月30日作成
              <br />
              作品C、7月22日作成
              <br />
              …
              <br />
              …
            </div>
            <RemoteSelectV2
              ref="selectV2Client"
              type="filmForSearch"
              :list="comFilmList"
              v-model="filmId"
              :isMultiple="false"
              :formValue.sync="filmId"
              :fields="['id', 'name']"
              @setList="arr => comFilmList = arr"
              :placeholder="$locale('trans.report.ticketing.plsInputFilmName')"
              :clearable="true"
              @change="selectFilm_fn"
          />
          </el-tooltip>
          
        </div>
        <div class="inputItem">
          <el-select
              v-model="scheduleDate"
              placeholder="上映日付を選択してください"
              clearable
              @change="selectDate_fn"
            >
              <el-option
                v-for="(date, idx) in scheduleDateLabels"
                :key="idx"
                :label="date.label"
                :value="date.label"
              ></el-option>
            </el-select>
        </div>
        <div class="inputItem">
          <el-select
              multiple
              v-model="scheduleId"
              :placeholder="$locale('trans.box.plsSelectSchedule')"
              clearable
            >
              <el-option
                v-for="(item, idx) in scheduleIds"
                :key="idx"
                :label="item.status === 'delete' ? item.schedule + '（削除済み）' : item.schedule"
                :value="item.id"
              ></el-option>
            </el-select>
        </div>
        <!-- <div class="inputItem payment">
          <el-select
              v-model="paymentTypeId"
              :placeholder="$locale('trans.other.selectPaymentName')"
              clearable
            >
              <el-option v-for="(payment, idx) in paymentTypeList" :key="idx" :value="payment.id" :label="payment.nameShow"></el-option>
            </el-select>
        </div> -->


        <el-button class="egl-btn-yellow" @click="search">
          {{ $locale("global.search") }}
        </el-button>
      </el-col>
    </el-row>
    <el-row class="search-area" style="margin-top: 0">
          <el-col class="ta-r">
            <el-button class="egl-btn-yellow" @click="openCreateDialog">{{ $locale("global.create") }}</el-button>
          </el-col>
    </el-row>
    <!-- <el-row class="search-area">
      <el-col class="ta-r">
        <el-button class="egl-btn-yellow" @click="openCreateDialog">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row> -->
    <!-- <el-row class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button @click="exportCsv" class="egl-btn-yellow"
          >{{ $locale("global.exportToCSV") }}</el-button
        >
      </el-col>
    </el-row> -->
    <div class="table-module" style="flex: 1;overflow: auto;margin-top: 10px;">
      <div id="print">
        <Table
          type="ticketing"
          :title="table"
          :data="tableData"
          ref="father"
          :size="size"
          :currentPage="currentPage"
          :filmList="filmList"
          :paymentTypeList="paymentTypes"
          :salesStatusObj="salesStatus"
        />
      </div>
    </div>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
      :pageSize="size"
      style="height: 34px;margin-right: 0;"
    />
    <!-- <Dialog
      :visible="isOpen"
      :titleText="$locale('trans.koisk.title')"

      :type="type"
      :btnText="type === 'edit' ? $locale('global.update') : $locale('global.confirm')"
      :closeAction="toggle"
      :confirmAction="toggle"
      :oneButton="type === 'edit' ? false : true"
      v-if="tableData.length > 0"
    >
      <div class="section">
        <div class="sectionInner">
          <Card
            :title="$locale('trans.koisk.transid')"
            :content="detailData.searchId"
          />
          <Card
            :title="$locale('global.titleOfWork')"
            :content="detailData.filmName"
          />
          <Card
            :title="$locale('trans.report.scheduleStartTime')"
            :content="detailData.scheduleStartTime"
          />
        </div>
        <div class="sectionInner">
          <Card
            :title="$locale('global.screen')"
            :content="detailData.houseName"
          />
          <Card
            :title="$locale('theatre.seatType')"
            :content="detailData.seatName"
          />
          <Card
            :title="$locale('global.date')"
            :content="detailData.transactionCreateTime"
          />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card
            title="券種"
            :content="detailData.ticketTypeName"
            v-if="type !== 'edit'"
          />
          <Card
            title="券種"
            content="select"
            type="select"
            value="水曜サービスデイ"
            v-else
          />
          <Card :title="$locale('global.coupon')" content="/" v-if="type !== 'edit'" />
          <Card
            title="券種"
            content="select"
            type="select"
            value="クーポン A"
            v-else
          />
          <Card
            :title="$locale('global.amount')"
            :content="
              '¥' + (detailData.ticketTypePrice)
            "
          />
          <Card
            :title="$locale('trans.report.paymentMethod')"
            :content="detailData.paymentName"
          />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card
            :title="$locale('trans.report.zhLastName')"
            :content="detailData.payerLastNameHant"
          />
          <Card
            :title="$locale('trans.report.zhFirstName')"
            :content="detailData.payerFirstNameHant"
          />
          <Card
            :title="$locale('trans.report.jpLastName')"
            :content="detailData.payerLastNameSyl"
          />
          <Card
            :title="$locale('trans.report.jpFirstName')"
            :content="detailData.payerFirstNameSyl"
          />
        </div>
        <div class="sectionInner">
          <Card
            :title="$locale('global.screen')"
            :content="detailData.houseName"
          />
          <Card
            :title="$locale('theatre.seatType')"
            :content="detailData.seatName"
          />
          <Card
            :title="$locale('global.date')"
            :content="detailData.transactionCreateTime"
          />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card
            :title="$locale('trans.report.paymentMethod')"
            :content="detailData.paymentName"
          />
          <Card :title="$locale('global.status')" content="/" />
          <Card
            :title="$locale('inventoryLog.changePeople')"
            :content="detailData.operator"
          />
        </div>
      </div>
    </Dialog> -->
    <el-dialog
      :visible.sync="isCreateOpen"
      width="1342px"
      class="egl-dialog-elm"
      @close="closeDialog"
      :title="titleMapping[type]"
      :close-on-click-modal="false"
    >
      <div class="form-module">
        <el-form
          label-position="top"
          :model="transCreateForm"
          ref="createForm"
          :rules="formRules"
          :disabled="type === 'info'"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.koisk.transid')">{{transCreateForm.searchId || "/"}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item :label="$locale('trans.report.ticketing.time')">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <CommDatePicker
                        v-model="transCreateForm.date"
                        :value.sync="transCreateForm.date"
                        width="100%"
                        :showWeekly="true"
                        :pickerOptions="datePickerOptions"
                      />
                    </el-col>
                    <el-col :span="4"><el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="transCreateForm.hour"
                      @input="(value) => hourMinuteLimit_fn(this.transCreateForm, value, 'hour')"
                    /></el-col>
                    <el-col :span="1" style="text-align: center">:</el-col>
                    <el-col :span="4"><el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="transCreateForm.minute"
                      @input="(value) => hourMinuteLimit_fn(this.transCreateForm, value, 'minute')"
                    /></el-col>
                  </el-row>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('global.titleOfWork')" prop="filmId">
                <el-select
                  :placeholder="$locale('trans.report.ticketing.plsInputFilmName')"
                  v-model="transCreateForm.filmId"
                  @change="getScheduleList_fn"
                  :filterable="true"
                  :disabled="type === 'edit'"
                >
                  <el-option
                    v-for="(item, idx) in filmList"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.releaseDate')" prop="releaseDate">
                <el-select
                  :placeholder="$locale('trans.report.ticketing.plsSelectReleaseDate')"
                  v-model="transCreateForm.releaseDate"
                  @change="getScheduleTime_fn"
                  :disabled="type === 'edit'"
                >
                  <el-option
                    v-for="(item, idx) in scheduleList"
                    :key="idx"
                    :label="item.yyMMdd"
                    :value="item.yyMMdd"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.releaseTime')" prop="scheduleId">
                <el-select
                  :placeholder="$locale('trans.report.ticketing.plsSelectReleaseDate')"
                  v-model="transCreateForm.scheduleId"
                  @change="getTicket_fn"
                  :disabled="type === 'edit'"
                >
                  <el-option
                    v-for="(item, idx) in scheduleTime"
                    :key="idx"
                    :label="item.hhmm"
                    :value="item.scheduleId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item
                :label="$locale('global.screen')"
                prop="houseName"
              >{{transCreateForm.houseName || "/"}}</el-form-item>
            </el-col>
            <el-col :span="3" prop="seatName">
              <el-form-item :label="$locale('theatre.seatType')" prop="seatName">
                <el-input :placeholder="$locale('trans.report.ticketing.SeatNamePlaceHolder')" v-model="transCreateForm.seatName" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.ticket')" prop="ticketTypeId">
                <el-select
                  :clearable="true"
                  :placeholder="$locale('client.text.choose')"
                  v-model="transCreateForm.ticketTypeId"
                  @change="selectTicket_fn"
                >
                  <el-option
                    :disabled="item.default === undefined && transCreateForm.couponTypeId && transCreateForm.couponTypeId.length > 0"
                    v-for="(item, idx) in ticketTypes"
                    :key="idx"
                    :label="item.name"
                    :value="item.uuid || item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.coupon')" prop="couponTypeId">
                <el-select
                  filterable
                  :clearable="true"
                  :disabled="curTicketObj && curTicketObj.default === undefined && transCreateForm.ticketTypeId !== ''"
                  :placeholder="$locale('client.text.choose')"
                  v-model="transCreateForm.couponTypeId"
                  @change="selectCoupon_fn"
                  multiple
                  :collapse-tags="true"
                >
                  <el-option
                    v-for="(item, idx) in couponTypes"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.amount')">{{"¥" + transCreateForm.totalAmount + " " + $locale("trans.report.ticketing.price")}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.zhLastName')">
                <el-input v-model="transCreateForm.chineseLastName" :placeholder="$locale('trans.report.ticketing.zhLastName')" v-if ="type === 'edit'" />
                <span v-else>{{transCreateForm.chineseLastName || "/"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.zhFirstName')">
                <el-input v-model="transCreateForm.chineseName" :placeholder="$locale('trans.report.ticketing.zhFirstName')" v-if="type === 'edit'" />
                <span v-else>{{transCreateForm.chineseName || "/"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.jpLastName')">
                <el-input v-model="transCreateForm.japaneseLastName" :placeholder="$locale('trans.report.ticketing.jpLastName')" v-if ="type === 'edit'" />
                <span v-else>{{transCreateForm.japaneseLastName || "/"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.jpFirstName')">
                <el-input v-model="transCreateForm.japaneseName" :placeholder="$locale('trans.report.ticketing.jpFirstName')" v-if ="type === 'edit'" />
                <span v-else>{{transCreateForm.japaneseName || "/"}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('setting.brand.tel')">
                <el-input v-model="transCreateForm.phone" :placeholder="$locale('setting.brand.tel')" v-if ="type === 'edit'" />
                <span v-else>{{transCreateForm.phone || "/"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.email')">
                <el-input v-model="transCreateForm.email" :placeholder="$locale('global.email')" v-if ="type === 'edit'" />
                <span v-else>{{transCreateForm.email || "/"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.memberNumber')">
                <!-- <el-input v-model="transCreateForm.membershipNumber" :placeholder="$locale('trans.report.ticketing.memberNumber')" v-if ="type === 'edit'" /> -->
                <span>{{transCreateForm.membershipNumber || "/"}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.payMethod')" prop="paymentTypeId">
                <el-select :placeholder="$locale('trans.report.ticketing.plsSelectPayMethod')" v-model="transCreateForm.paymentTypeId">
                  <el-option
                    v-for="(item, idx) in (type === 'create' ? paymentTypes : originPaymentTypes)"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.status')">{{salesStatus[transCreateForm.status]}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('inventoryLog.changePeople')">{{transCreateForm.userName}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.gmoOrderId')">{{transCreateForm.gmoOrderId}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.gmoErrMsg')">{{transCreateForm.gmoErrMsg ? transCreateForm.gmoErrMsg : (transCreateForm.status === 'confirming' ? '3DS2.0個人認証失敗' : '/') }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.sendEmail')">{{
                transCreateForm.sendEmail ? "成功" : transCreateForm.sendEmailErrMsg
              }}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="伝票番号">{{transCreateForm.orderId}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="承認番号">{{transCreateForm.approvalNumber}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row>
            <el-col :span="20">
              <el-form-item :label="$locale('inventoryLog.inventoryChangeSupplement')" prop="comment">
                <el-input :placeholder="$locale('trans.report.ticketing.plsSelectComment')" v-model="transCreateForm.comment"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="type !== 'info'">
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <el-button @click="closeDialog" class="egl-btn-white">{{
              $locale("global.cancel")
            }}</el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              class="egl-btn-yellow"
              @click="submitCreateForm"
            >
              {{ $locale("global.update") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
</style>

<script>
import "@/assets/style/transactionHistory.less";
// import moment from "moment";
// import elTableExport from "el-table-export";
import CommDatePicker from "@/components/common/CommDatePicker";
import DatePickerGroup from "@/components/DatePickerGroup";
// import Dialog from "@/components/Version/dialog.vue";
import CommPagination from "@/components/common/CommPagination";
import Table from "@/components/Report/table.vue";
// import Card from "@/components/Report/card.vue";
import CusInputItem from "@/components/Report/CusInputItem.vue";
import {
  ticketSalesReportService, delProductSalesReportService, createTicketTransactionService, getScheduleListForTransaction,
  getTicketTypesForTransaction, updateTicketTransactionService, ticketTransactionDetail, getDateListByFilmId
} from "@/helpers/service/api/report";
import { getSimpleMovieList } from "@/helpers/service/api/common";
import { salesStatus, getOperatorText } from "@/utils/common.js";
import { getPaymentTypeList, getPaymentTypeListService } from "@/helpers/service/api/device";
import { generateTimeStamp, generateTimeString, hourMinuteLimit_fn } from "@/utils/transaction";
import countDownAlert from "@/utils/countDownAlert";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { exportCSV_fn } from "@/assets/js/transactionHistory_exportCSV";
import { weekLocaleArray } from "@/utils/common";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";

import filterOptions from "@/mixins/filterOptions";
import { localStorage } from '@/utils/localStorage'
import { saveFilterOptions } from "@/utils/filterOptions";

export default {
  mixins: [ filterOptions ],
  components: {
    RemoteSelectV2,
    Table,
    // Dialog,
    // Card,
    CusInputItem,
    CommPagination,
    DatePickerGroup,
    CommDatePicker,
  },
  async created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    await this.getComFilmList();
    // console.log(this.filmId, this.comFilmList);
    if (this.filmId && !this.comFilmList.find((item) => item.id === this.filmId)) {
      await getSimpleMovieList({
        ids: [ this.filmId ],
        approve: true,
        page: 0,
        pageSize: 99999,
        cinemaId: this.cinemaId,
        field: ["id", "name"],
        hiddenCms: false,
      }).then((res) => {
        this.comFilmList = [...res.data.data, ...this.comFilmList];
      })
    }
    // 拿全部filmList用于mapping movieName
    getSimpleMovieList({
      approve: true,
      page: 0,
      pageSize: 99999,
      cinemaId: this.cinemaId,
      field: ["id", "name"],
      hiddenCms: false,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.filmList = res.data.data;
      }
    });
    getPaymentTypeList({
      forPos: "true",
      page: 0,
      pageSize: 9999,
      cinemaId: this.cinemaId,
    }).then(res => {
      this.originPaymentTypes = res.data.data;
      // let _arr = JSON.parse(JSON.stringify(res.data.data)).filter(item => item.type === "cash" || item.type === "creditCard" || item.type === "gmo");
      this.paymentTypes = res.data.data;
    });
    this.salesStatus = salesStatus;

    getPaymentTypeListService({
      cinemaId: window.localStorage.getItem("cinemaId")
    }).then(res => {
      this.paymentTypeList = res.data.data;
    });
  },
  async mounted() {
    const today = this.$moment().valueOf();
    this.timeValue1 = today;
    this.timeValue2 = today;

    if (!this.cinemaId) {
      this.$emit("callCinema", "getHistoryList");
      return;
    }
    await this.loadOptions('transaction-history', async (val) => {
      const {
        zhFirstName,
        zhLastName,
        email,
        jpFirstName,
        jpLastName,
        phone,
        id,
        filmId,
        scheduleDate,
        scheduleId,
        paymentTypeId
      } = val.options;
      // Object.keys(val.options).forEach(key => {
      //   this.cusInputFn(key, val.options[key])
      // })
      this.email = email;
      this.chineseName = zhFirstName;
      this.chineseLastName = zhLastName;
      this.japaneseName = jpFirstName;
      this.japaneseLastName = jpLastName;
      this.phone = phone;
      this.id = id;
      this.paymentTypeId = paymentTypeId;

      // 处理film部分
      this.filmId = filmId;
      // 通过filmId 获取scheduleList
      await this.selectFilm_fn(filmId);
      if (filmId) {
        this.scheduleDate = scheduleDate;
        this.selectDate_fn(scheduleDate);
        this.scheduleId = scheduleId;
      }
    })
    this.getHistoryList();
    // 绑定键盘事件
    document.addEventListener("keyup", this.handlerKeyUp);
  },
  data() {
    return {
      cinemaId: "",
      timeValue1: this.$moment().valueOf(),
      timeValue2: this.$moment().valueOf(),
      id: "",
      chineseName: "",
      chineseLastName: "",
      japaneseName: "",
      japaneseLastName: "",
      phone: "",
      email: "",
      filmId: "",
      scheduleDate: "",
      scheduleId: [],
      scheduleDateLabels: [],
      scheduleDateDatas: [],
      scheduleIds: [],
      filmListForSearch: [],
      paymentTypeId: "",
      payment_filters: "",
      paymentTypeList: [],
      table: [
        {
          prop: "searchId",
          label: this.$locale("trans.koisk.transid"),
          width: 230
        },
        {
          prop: "transactionCreateTime",
          label: this.$locale("global.date"),
          width: 180
        },
        {
          prop: "filmName",
          label: this.$locale("global.titleOfWork"),
          width: 200
        },
        {
          prop: "scheduleDate",
          label: this.$locale("operation.NAT.screenDate"),
          width: 180
        },
        {
          prop: "scheduleTime",
          label: this.$locale("operation.NAT.showTime"),
          width: 180
        },

        {
          prop: "houseName",
          label: this.$locale("global.screen"),
          width: 120
        },
        {
          prop: "seatName",
          label: this.$locale("theatre.seatType"),
          width: 70
        },
        {
          prop: "ticketTypeName",
          label: this.$locale("trans.report.ticketTypeName"),
          width: 120
        },
        {
          prop: "couponTypeName",
          label: this.$locale("global.coupon"),
          width: 200
        },
        {
          prop: "total",
          label: this.$locale("global.amount"),
          width: 120
        },
        {
          prop: "paymentName",
          label: this.$locale("trans.report.paymentMethod"),
          width: 150
        },
        {
          prop: "userName",
          label: this.$locale("trans.userName"),
          width: 150,
        },
        {
          prop: "mobile",
          label: this.$locale("setting.brand.tel"),
          width: 150,
        },
        {
          prop: "operator",
          label: this.$locale("inventoryLog.changePeople"),
          width: 160
        },
        {
          prop: "statusText",
          label: this.$locale("global.status"),
          width: 110
        }
      ],
      originData: {},
      allTableData: [],
      tableData: [],
      isOpen: false,
      isCreateOpen: false,
      type: "",
      transIndex: 0,
      size: 10,
      currentPage: 0,
      detailData: {},
      count: 0,
      transCreateForm: this.initCreateForm(),
      filmList: [],
      scheduleList: [],
      scheduleTime: [],
      ticketTypes: [],
      couponTypes: [],

      originPaymentTypes: [],
      paymentTypes: [],
      salesStatus: {},
      hourMinuteLimit_fn,
      formRules: {
        filmId: [
          {
            required: true,
            message: this.$locale("trans.report.ticketing.plsInputFilmName"),
            trigger: "blur",
          },
        ],
        releaseDate: [
          {
            required: true,
            message: this.$locale("trans.report.ticketing.plsSelectReleaseDate"),
            trigger: "blur",
          },
        ],
        scheduleId: [
          {
            required: true,
            message: this.$locale("trans.report.ticketing.plsSelectReleaseTime"),
            trigger: "blur",
          },
        ],
        seatName: [
          {
            required: true,
            message: this.$locale("trans.report.ticketing.plsInputSeatName"),
            trigger: "blur",
          },
        ],
        ticketTypeId: [
          {
            required: true,
            message: this.$locale("trans.report.ticketing.plsSelectTicket"),
            trigger: "blur",
          },
        ],
      },
      curTicketObj: {},
      curCouponObj: {},
      titleMapping: {
        "create": this.$locale("trans.ticketing.create"),
        "info": this.$locale("trans.ticketing.detail"),
        "edit": this.$locale("trans.ticketing.edit"),
      },
      // setFinishTime,
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      sort: "",
      // filters: [],
      status_filters: [],
      printObj: {
        popTitle: this.$locale("sideMenu.reports.ticketTransaction"),
        id: "print",
      },
      isListLoading: false,
      comFilmList: [],
    };
  },
  methods: {
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.timeValue1 = startDate;
      }
      if (endDate) {
        this.timeValue2 = endDate;
      }
    },
    formatDate(timestamp) {
      return this.$moment(timestamp).format("YYYY-MM-DD");
    },
    getHistoryList(isFilter = false, isPaging = false) {
      this.isListLoading = true;
      const that = this;
      if (isFilter) that.currentPage = 0;
      const requestParma = {
        startDate: that.formatDate(that.timeValue1),
        endDate: that.formatDate(that.timeValue2),
        cinemaId: that.cinemaId,
        page: that.currentPage,
        pageSize: that.size,
        ...that.zhFirstName ? { chineseName: that.zhFirstName } : {},
        ...that.zhLastName ? { chineseLastName: that.zhLastName } : {},
        ...that.email ? { email: that.email } : {},
        ...that.jpFirstName ? { japaneseName: that.jpFirstName } : {},
        ...that.jpLastName ? { japaneseLastName: that.jpLastName } : {},
        ...that.phone ? { phoneNumber: that.phone } : {},
        ...that.id ? { searchId: that.id.replace(' ', '') } : {},
        ...that.filmId ? { filmId: that.filmId } : {},
        // ...isFilter ? {
        //   paymentTypeId: that.payment_filters
        // } : isPaging ? {
        //   paymentTypeId: that.paymentTypeId || that.payment_filters
        // } : that.paymentTypeId ? { paymentTypeId: that.paymentTypeId } : {},
        paymentTypeId: that.payment_filters,
        ...this.sort ? { sort: this.sort } : {},
        ...this.status_filters ? { status: this.status_filters } : {},
        ...this.scheduleIds && this.scheduleIds.length > 0 ? { scheduleIds: this.scheduleId.length > 0 ? this.scheduleId : this.scheduleIds.map(item => item.id) } : {}
      };

      ticketSalesReportService(requestParma).then(res => {
        this.isListLoading = false;
        that.count = res.data.count ||0;
        if (res.data.records.length > 0) {
          that.tableData = res.data.records;
          that.tableData.map(item => {
            item.operator = getOperatorText(item);
            item.scheduleDate = this.$moment(item.scheduleStartTime).format("YYYY-MM-DD");
            item.scheduleTime = this.$moment(item.scheduleStartTime).format("HH:mm");
            item.userName = item.payerLastNameHant + item.payerFirstNameHant;
          });
        } else {
          that.tableData = [];
        }
      }).catch(() => {
        this.isListLoading = false;
      });
    },
    cusInputFn(name, value) {
      this[name] = value;
    },
    search() {
      saveFilterOptions({
        id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
        options: {
          // timeValue1: this.timeValue1,
          // timeValue2: this.timeValue2,
          zhFirstName: this.zhFirstName,
          zhLastName: this.zhLastName,
          email: this.email,
          jpFirstName: this.jpFirstName,
          jpLastName: this.jpLastName,
          phone: this.phone,
          id: this.id,
          filmId: this.filmId,
          paymentTypeId: this.paymentTypeId,
          scheduleDate: this.scheduleDate,
          scheduleId: this.scheduleId,
        }
      }, 'transaction-history')
      this.currentPage = 0;
      this.getHistoryList();
    },
    toggle(type) {
      this.isCreateOpen = !this.isCreateOpen;
      if (type) {
        this.type = type;
      }
      // index && (this.transIndex = index - 1)
    },
    setDetailData(data) {
      this.ticketTypes = [];
      this.couponTypes = [];
      requestAll([getScheduleListForTransaction({
        cinemaId: this.cinemaId,
        filmId: data.filmName,
        transactionTime: data.transactionCreateTime,
      }), getTicketTypesForTransaction({
        scheduleId: data.scheduleId
      }), ticketTransactionDetail({
        transactionId: data.transactionId,
        transactionItemId: data.transactionItemId
      })]).then(res => {
        const {
          searchId, filmName, scheduleStartTime, scheduleId, houseName, ticketTypeId, couponTypeName, ticketTypePrice,
          transactionCreateTime, transactionId, transactionItemId, seatName, payerFirstNameHant, payerFirstNameSyl,
          payerLastNameHant, payerLastNameSyl, mobile, email, paymentName, description, itemStatus, platform, operator,
          gmoOrderId, orderId, approvalNumber, gmoErrMsg, sendEmail, sendEmailErrMsg, membershipNumber
        } = res[2].data;
        this.scheduleList= res[0].data;
        const curScheduleTime = this.scheduleList.find(item => item.yyMMdd === this.$moment(scheduleStartTime).format("YYYY-MM-DD"));
        this.scheduleTime = curScheduleTime ? curScheduleTime.hhmmList : [];
        this.setTicket_fn(res[1]);
        const curTicketItem = this.ticketTypes.find(item => item.uuid === this.transCreateForm.ticketTypeId || item.id === this.transCreateForm.ticketTypeId);
        this.curTicketObj = curTicketItem;
        const curCouponItem = this.couponTypes.find(item => item.id === this.transCreateForm.couponTypeId);
        if (curCouponItem) {
          this.curCouponObj = curCouponItem;
        }

        const _couponTypeName = couponTypeName.replace(/\s+/g, "");
        const _couponTypeId = _couponTypeName ? _couponTypeName.split(",") : [];

        this.transCreateForm = {
          searchId: searchId,
          filmId: filmName,
          releaseDate: this.$moment(scheduleStartTime).format("YYYY-MM-DD"),
          scheduleId: scheduleId,
          houseName: houseName,
          ticketTypeId: ticketTypeId,
          couponTypeId: _couponTypeId,
          totalAmount:  ticketTypePrice,
          date: transactionCreateTime,
          hour: this.$moment(transactionCreateTime).format("HH"),
          minute: this.$moment(transactionCreateTime).format("mm"),
          transactionId: transactionId,
          transactionItemId: transactionItemId,
          seatName: seatName,
          chineseName: payerFirstNameHant,
          chineseLastName: payerLastNameHant,
          japaneseName: payerFirstNameSyl,
          japaneseLastName: payerLastNameSyl,
          phone: mobile,
          email: email,
          membershipNumber,
          paymentTypeId: paymentName,
          userName: platform + "/" + operator,
          userId: window.localStorage.getItem("accountId"),
          comment: description,
          status: itemStatus,
          gmoOrderId,
          orderId,
          approvalNumber,
          gmoErrMsg,
          sendEmailErrMsg,
          sendEmail,
        };
      });
    },
    delete(data) {
      const {
        chineseName, chineseLastName, comment, couponTypeId, email, filmId, japaneseName, japaneseLastName,
        phone, paymentTypeId, scheduleId, searchId, seatName, status, totalAmount,
        transactionId, transactionItemId, userId, userName, ticketTypeId, houseName
      } = this.transCreateForm;
      const curTicketItem = this.ticketTypes.find(item => item.uuid === ticketTypeId || item.id === ticketTypeId);
      const isDefault = curTicketItem && curTicketItem.default;
      const isMVTK = curTicketItem && curTicketItem.type === "MVTK";
      const isOTMVTK = curTicketItem && curTicketItem.type === "OTMVTK";
      let confirmHtml = this.type ? "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        this.$locale("trans.update.tips") +
        "</span>" :
        "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        this.$locale(data.searchId) + this.$locale("version.screen.action.del") +
        "</span>";
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          if (!this.type) {
            delProductSalesReportService({
              itemId: data.transactionItemId,
              transactionId: data.transactionId,
              userId: window.localStorage.getItem("accountId")
            }).then(() => {
              // for (let i = 0; i < this.tableData.length; i++) {
              //   if (
              //     this.tableData[i].transactionItemId === data.transactionItemId
              //   ) {
              //     this.tableData.splice(i, 1);
              //     return;
              //   }
              // }
              this.search();
            });
          } else {
            const _couponTypeId = couponTypeId ? couponTypeId.join(",") : couponTypeId;

            updateTicketTransactionService({
              chineseName,
              chineseLastName,
              cinemaId: this.cinemaId,
              comment,
              couponTypeId: _couponTypeId,
              email,
              filmId,
              houseName,
              japaneseName,
              japaneseLastName,
              mobile: phone,
              paymentTypeId,
              ...isDefault === undefined ? ((isMVTK || isOTMVTK) ? { commonCouponTypeId: ticketTypeId, ...isOTMVTK ? { ticketTypeEnum : "MOVIETICKTINGOTHER" } : {} } : { advanceCouponTypeId: ticketTypeId }) : (isDefault ? {
                generalTicketId: ticketTypeId
              } : { otherTicketId: ticketTypeId }),
              scheduleId,
              searchId,
              seatName,
              status,
              timeString: this.timeString,
              totalAmount,
              transactionFinishTime: this.transactionFinishTime,
              transactionId,
              transactionItemId,
              userId,
              userName
            }).then(res => {
              this.closeDialog();
              if (res.data) {
                countDownAlert({
                  content: this.$locale("global.updateSuccessfully"),
                  callback: () => {
                    this.getHistoryList();
                  }
                });
              }
            });
          }
        });
    },
    exportCsv() {
      // const that = this;
      // if (that.tableData.length > 0) {
      //   this.size = 0;
      //   this.$nextTick(function() {
      //     elTableExport(that.$refs.father.$refs.elTable, {
      //       fileName: "export-trans",
      //       type: "csv",
      //       withBOM: false
      //     })
      //       .then(() => {
      //         that.size = 10;
      //       })
      //       .catch(() => {
      //         that.size = 10;
      //       });
      //   });
      // }
      const that = this;
      const requestParma = {
        startDate: that.formatDate(that.timeValue1),
        endDate: that.formatDate(that.timeValue2),
        cinemaId: that.cinemaId,
        page: 0,
        pageSize: 999999,
        chineseName: that.zhFirstName || null,
        chineseLastName: that.zhLastName || null,
        email: that.email || null,
        japaneseName: that.jpFirstName || null,
        japaneseLastName: that.jpLastName || null,
        phoneNumber: that.phone || null,
        searchId: that.id || null,
        ...this.sort ? { sort: this.sort } : {},
        ...this.filters ? { status: this.filters } : {},
        ...this.filmId ? { filmId: this.filmId } : {},
        ...this.paymentTypeId ? { paymentTypeId: this.paymentTypeId } : {},
        ...this.scheduleIds.length > 0 ? { scheduleIds: this.scheduleId.length > 0 ? this.scheduleId : this.scheduleIds.map(item => item.id) } : {}
      };
      exportCSV_fn(requestParma, this.filmList, this.timeValue1, this.timeValue2, weekLocaleArray);
    },
    pageChange(value) {
      if (!value) { return; }

      this.currentPage = value - 1;
      this.getHistoryList(false, true);
    },
    // timeFormat(res) {
    //   let arr = res.data.records;
    //   for (let i = 0; i < arr.length; i++) {
    //     arr[i].scheduleStartTime = moment(arr[i].scheduleStartTime).format("YYYY-MM-DD HH:mm");
    //     arr[i].transactionCreateTime = moment(arr[i].transactionCreateTime).format("YYYY-MM-DD HH:mm");
    //     arr[i].ticketTypePrice =
    //       arr[i].ticketTypePrice + arr[i].premiumPrice + arr[i].vipSeatPrice;
    //     arr[i] = {
    //       ...arr[i],
    //       statusText: salesStatus[arr[i].itemStatus],
    //     };
    //   }
    //   return arr;
    // },
    openCreateDialog() {
      this.isCreateOpen = true;
      this.type = "create";
    },
    closeDialog() {
      this.$refs["createForm"].resetFields();
      this.transCreateForm = this.initCreateForm();
      this.ticketTypes = [];
      this.couponTypes = [];
      this.scheduleList = [];
      this.scheduleTime = [];
      this.isCreateOpen = false;
      this.type = "";
    },
    initCreateForm() {
      return {
        searchId: "",
        date: this.$moment().startOf("day").valueOf(),
        hour: "",
        minute: "",
        filmId: "",
        releaseDate: "",
        releaseTime: "",
        houseName: "",
        scheduleId: "",
        seatName: "",
        ticketTypeId: "",
        couponTypeId: [],
        paymentTypeId: "",
        userName: window.localStorage.getItem("userName"),
        userId: window.localStorage.getItem("accountId"),
        comment: "",
        totalAmount: 0,
        chineseName: "",
        chineseLastName: "",
        japaneseName: "",
        japaneseLastName: "",
        phone: "",
        email: "",
        membershipNumber: "",
        status: "success",
        sendEmailErrMsg: ""
      };
    },
    submitCreateForm() {
      const {
        comment, couponTypeId, filmId,
        paymentTypeId, scheduleId, seatName, totalAmount,
        userId, ticketTypeId
      } = this.transCreateForm;
      const curTicketItem = this.ticketTypes.find(item => item.uuid  === ticketTypeId || item.id === ticketTypeId);
      const isDefault = curTicketItem && curTicketItem.default;
      const isMVTK = curTicketItem && curTicketItem.type === "MVTK";
      const isOTMVTK = curTicketItem && curTicketItem.type === "OTMVTK";

      this.$refs["createForm"].validate(valid => {
        if (valid) {
          if (this.transCreateForm.hour === "" || this.transCreateForm.minute === "") {
            this.$alert(this.$locale("trans.plsInput.time"));
          }
          else if (this.type === "create") {
            const _couponTypeId = couponTypeId ? couponTypeId.join(",") : couponTypeId;

            createTicketTransactionService({
              // accountId: window.localStorage.getItem("accountId"),
              cinemaId: this.cinemaId,
              comment,
              couponTypeId: _couponTypeId,
              filmId,
              paymentTypeId,
              scheduleId,
              seatName,
              // ticketTypeId,
              ...isDefault === undefined ? ((isMVTK || isOTMVTK) ? { commonCouponTypeId: ticketTypeId, ...isOTMVTK ? { ticketTypeEnum : "MOVIETICKTINGOTHER" } : {} } : { advanceCouponTypeId: ticketTypeId }) : (isDefault ? {
                generalTicketId: ticketTypeId
              } : { otherTicketId: ticketTypeId }),
              totalAmount,
              userId,
              timeString: this.timeString,
              transactionFinishTime: this.transactionFinishTime,
            }).then(() => {
              this.$alert(this.$locale("global.createSuccessfully"));
              this.getHistoryList();
              // this.closeDialog();
              // countDownAlert({
              //   content: this.$locale("global.createSuccessfully"),
              //   callback: () => {
              //     this.getHistoryList();
              //   }
              // });
            });
          } else {
            this.delete();
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    getScheduleList_fn() {
      this.transCreateForm.releaseDate = "";
      this.transCreateForm.scheduleId = "";
      this.transCreateForm.ticketTypeId = "";
      this.transCreateForm.couponTypeId = [];
      this.ticketTypes = [];
      this.couponTypes = [];
      getScheduleListForTransaction({
        cinemaId: this.cinemaId,
        filmId: this.transCreateForm.filmId,
        transactionTime: this.transactionFinishTime,
      }).then(res => {
        this.scheduleList = res.data;
      });
    },
    getScheduleTime_fn() {
      this.transCreateForm.scheduleId = "";
      this.transCreateForm.ticketTypeId = "";
      this.transCreateForm.couponTypeId = [];
      this.ticketTypes = [];
      this.couponTypes = [];
      const curTimeArr = this.scheduleList.find(item => item.yyMMdd === this.transCreateForm.releaseDate);
      this.scheduleTime = curTimeArr.hhmmList;
      const curScheduleItem = this.scheduleTime.find(item => item.scheduleId === this.transCreateForm.scheduleId);
      this.transCreateForm.version = curScheduleItem ? curScheduleItem.version : "";
    },
    getTicket_fn() {
      this.transCreateForm.ticketTypeId = "";
      this.transCreateForm.couponTypeId = [];
      this.ticketTypes = [];
      this.couponTypes = [];
      getTicketTypesForTransaction({
        scheduleId: this.transCreateForm.scheduleId
      }).then(res => {
        this.setTicket_fn(res);
      });
    },
    setTicket_fn(res) {
      const { generalTicket, otherTickets, advanceCouponTypes, couponTypes, movieTicketList, otherMovieTicketList } = res.data;
      if (generalTicket !== null) {
        this.ticketTypes.push({
          name: generalTicket.name,
          price: generalTicket.price,
          default: generalTicket.default,
          uuid: generalTicket.uuid
        });
      }
      if (otherTickets.length > 0 && otherTickets[0].ticketTypes.length > 0) {
        otherTickets[0].ticketTypes.forEach(item => {
          this.ticketTypes.push(item);
        });
      }
      if (advanceCouponTypes.length > 0) {
        advanceCouponTypes.forEach(item => {
          this.ticketTypes.push({
            name: item.name,
            id: item.id,
            price: 0
          });
        });
      }
      if (couponTypes.length > 0) {
        couponTypes.forEach(item => {
          this.couponTypes.push({
            name: item.name,
            id: item.id
          });
        });
      }
      if (movieTicketList && movieTicketList.length > 0) {
        movieTicketList.forEach(item => {
          this.ticketTypes.push({
            name: item.name,
            id: item.id,
            price: 0,
            type: "MVTK",
          });
        });
      }

      if (otherMovieTicketList && otherMovieTicketList.length > 0) {
        otherMovieTicketList.forEach(item => {
          this.ticketTypes.push({
            name: item.name,
            id: item.uuid,
            price: 0,
            type: "OTMVTK",
          });
        });
      }
    },
    selectTicket_fn(value) {
      let curTicketItem;
      if (value) {
        curTicketItem = this.ticketTypes.find(item => item.uuid === this.transCreateForm.ticketTypeId || item.id === this.transCreateForm.ticketTypeId);
        this.curTicketObj = curTicketItem;
      }
      this.transCreateForm.totalAmount = curTicketItem ? curTicketItem.price : 0;
    },
    selectCoupon_fn(value) {
      let curCouponItem;
      if (value) {
        curCouponItem = this.couponTypes.find(item => item.id === this.transCreateForm.couponTypeId);
      }
      this.curCouponObj = curCouponItem;
    },
    setFinishTime(num) {
      this.transCreateForm.date = num;
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
    handlerKeyUp(e) {
      if (!this.isListLoading) {
        let key = window.event ? e.keyCode : e.which;
        if (key === 37) {
          if (this.currentPage > 0) {
            this.currentPage--;
            this.getHistoryList();
          } else {
            this.currentPage = 0;
          }
          // return
        } else if (key === 39) {
          if (this.currentPage < Math.ceil(this.count / 10) - 1) {
            this.currentPage++;
            this.getHistoryList();
          } else {
            this.currentPage = Math.ceil(this.count / 10) - 1;
          }
        }
      }
    },
    // searchDateListByFilmId
    async selectFilm_fn(val) {
      this.scheduleDate = "";
      this.scheduleId = "";
      this.scheduleDateLabels = [];
      this.scheduleIds = [];
      if (val) {
        try {
          const res = await getDateListByFilmId({
            cinemaId: window.localStorage.getItem("cinemaId"),
            filmId: val,
          });
          if (res.data && res.data.length > 0) {
            const _list = JSON.parse(JSON.stringify(res.data));
            // 日期分类
            this.scheduleDateDatas = this.$_.groupBy(_list.map(item => ({
              status: item.status,
              name: `${this.$moment(item.startTime).format("YYYY-MM-DD")}（${weekLocaleArray[this.$moment(item.startTime).day()]}）`,
              id: item.id,
              schedule: `${this.$moment(item.startTime).format("HH:mm")} ~ ${this.$moment(item.endTime).format("HH:mm")}`,
              startTime: item.startTime
            })), "name");
            // 日期排序
            this.scheduleDateLabels = Object.keys(this.scheduleDateDatas).map(key => ({
              label: key,
              // 时间排序
              startTime: this.scheduleDateDatas[key][0].startTime,
              scheduleList: this.$_.sortBy(this.scheduleDateDatas[key], "startTime")
            }));
            this.scheduleDateLabels = this.$_.sortBy(this.scheduleDateLabels, "startTime").reverse();
          }
        } catch (error) {
          console.error("Error fetching date list by film ID:", error);
        }
      } else {
        this.getComFilmList();
      }

    },
    selectDate_fn(val) {
      this.scheduleId = "";
      this.scheduleIds = [];
      console.log(this.scheduleDateLabels);
      this.scheduleIds = (this.scheduleDateLabels.find(item => item.label === val) || {}).scheduleList;
    },
    async getComFilmList() {
      await getSimpleMovieList({
        approve: true,
        page: 0,
        pageSize: 20,
        cinemaId: this.cinemaId,
        field: ["id", "name"],
        hiddenCms: false,
      }, false).then(res => {
        if (res.data && res.data.data.length > 0) {
          this.comFilmList = res.data.data;
        } else {
          this.comFilmList = [];
        }
      });
    },
  },
  computed: {
    transactionFinishTime() {
      return generateTimeStamp(this.transCreateForm);
    },
    timeString() {
      return generateTimeString(this.transCreateForm);
    },
  },
};
</script>
<style lang="less" scoped>
  .inputItem {
    float: left;
    margin: 15px 10px 15px 0;
    &.payment {
      width: 250px;
    }
  }
  .search-area {
    margin-bottom: 0;
  }
</style>

